import { useLocation } from 'react-router-dom';
import { CampaignPlan } from 'sonata-static-storage/lib/schemas/multiFlight/campaignPlan.schema';

import { type Advertiser, AdvertiserForm } from '@/components/campaigns/AdvertiserForm';
import { CampaignPlanProvider } from '@/context/CampaignPlanProvider';
import { useGlobalStore } from '@/store/global';
import { getSessionByKeys } from '@/store/global/session/selectors';

export default function AdvertiserModal() {
  const location = useLocation();
  const campaignPlan = location?.state?.campaignPlan as CampaignPlan | undefined;
  const advertiser = location?.state?.advertiser as Advertiser | undefined;
  const { user: userId = '' } = useGlobalStore(store => getSessionByKeys(store, ['user']));

  return (
    <CampaignPlanProvider campaignPlan={campaignPlan} userId={userId}>
      <AdvertiserForm advertiser={advertiser || {}} />
    </CampaignPlanProvider>
  );
}
